import { MASKS } from '@/utilities/constants';
import MESSAGES from '@/validations/onboarding/error-messages';

export function splitInLines(text = '', maxLen = 30) {
  if (!text) return [];
  if (text.length <= maxLen) return [text];

  const parts = text.trim().split(' ');
  const lines = [];
  let index = 0;

  while (parts.length !== 0) {
    const part = parts.shift();
    if ((lines[index] + ` ${part}`).length > maxLen) {
      ++index;
      lines[index] = part;
      continue;
    }
    lines[index] = !lines[index] ? part : `${lines[index]} ${part}`;
  }
  return lines;
}

export function compact(array) {
  return array.filter((i) => i && i.length > 0);
}

export const hashedEmail = async (email) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(email);

  const buffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(buffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

// Function is similar to how the lodash pick works
export const pick = (object, keys) => {
  if (!object || typeof object !== 'object') {
    throw new Error('First argument must be an object');
  }

  if (!Array.isArray(keys)) {
    throw new Error('Second argument must be an array of keys');
  }

  const result = {};
  keys.forEach((key) => {
    if (key in object) {
      result[key] = object[key];
    }
  });

  return result;
};

export const getPhoneNumberMask = (isForeign) => {
  return isForeign ? MASKS.phoneNumberForeign : MASKS.phoneNumberUSA;
};

export const formatErrors = (field = {}) => {
  const errors = [];
  for (const error of field.$errors) {
    if (MESSAGES[error.$validator]) {
      errors.push(
        MESSAGES[error.$validator]({
          $pending: error.$pending,
          $invalid: field.$invalid,
          $params: error.$params,
          $model: field.$model,
        })
      );
    } else {
      errors.push(error.$message);
    }
  }
  return errors.length > 0 ? errors.filter((message) => message).join(', ') : '';
};

export const currency = function (s) {
  if (!s) return '';
  if (typeof s === 'string') s = parseFloat(s);

  const formatted = s.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  return s % 1 === 0 ? '$' + parseInt(s).toLocaleString() : '$' + formatted;
};

export const humanize = function (s) {
  if (typeof s !== 'string') return '';
  return s.replace(/([A-Z])/g, '$1').replace(/^./, function (str) {
    return str.toUpperCase();
  });
};
